import { useTranslation } from "react-i18next";

export function useI18n() {
  const { t, i18n } = useTranslation();

  const language = i18n.language;
  const isSpanish = language === "es";
  const isEnglish = language === "en";

  return {
    t,
    i18n,
    language,
    isSpanish,
    isEnglish,
    changeLanguage: i18n.changeLanguage.bind(i18n),
  };
}
